module.exports = __webpack_public_path__ + "static/img/grow1.a142fb1c.png";